// Servicio para manejar la autenticación
const API_BASE_URL = "https://lawfeedback.onrender.com"

/**
 * Función para iniciar sesión con credenciales (email y password)
 * @param {string} email - Correo electrónico del usuario
 * @param {string} password - Contraseña del usuario
 * @returns {Promise<Object>} - Datos del usuario y tokens
 */
export const loginWithCredentials = async (email, password) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || "Error al iniciar sesión")
    }

    const data = await response.json()

    // Guardar los tokens en cookies
    document.cookie = `token=${data.token}; path=/; max-age=${60 * 60 * 24 * 7}` // 1 semana
    document.cookie = `refreshToken=${data.refreshToken}; path=/; max-age=${60 * 60 * 24 * 7}` // 1 semana
    document.cookie = `userData=${JSON.stringify(data.userData)}; path=/; max-age=${60 * 60 * 24 * 7}` // 1 semana
console.log(data)
    return data
  } catch (error) {
    console.error("Error en loginService:", error)
    throw error
  }
}

/**
 * Función para iniciar sesión con Google
 * @param {Object} userData - Datos del usuario de Google
 * @returns {Promise<Object>} - Datos del usuario y tokens
 */
export const loginWithGoogle = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ UserData: { id: userData.id } }),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || "Error al iniciar sesión con Google")
    }

    const data = await response.json()

    // Guardar los tokens en cookies
    document.cookie = `token=${data.token}; path=/; max-age=${60 * 60 * 24 * 7}` // 1 semana
    document.cookie = `refreshToken=${data.refreshToken}; path=/; max-age=${60 * 60 * 24 * 7}` // 1 semana
    document.cookie = `userData=${JSON.stringify(data.userData)}; path=/; max-age=${60 * 60 * 24 * 7}` // 1 semana

    return data
  } catch (error) {
    console.error("Error en loginService (Google):", error)
    throw error
  }
}

/**
 * Función para refrescar el token de acceso
 * @param {string} refreshToken - Token de refresco
 * @returns {Promise<Object>} - Nuevo token de acceso
 */
export const refreshToken = async (refreshToken) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refreshToken }),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || "Error al refrescar el token")
    }

    const data = await response.json()

    // Actualizar el token en cookies
    document.cookie = `token=${data.token}; path=/; max-age=${60 * 60 * 24 * 7}` // 1 semana

    return data
  } catch (error) {
    console.error("Error en refreshToken:", error)
    throw error
  }
}

/**
 * Función para cerrar sesión
 */
export const logout = () => {
  // Eliminar cookies
  document.cookie = "token=; path=/; max-age=0"
  document.cookie = "refreshToken=; path=/; max-age=0"
  document.cookie = "userData=; path=/; max-age=0"

  // Redireccionar a la página de inicio
  window.location.href = "/"
}

/**
 * Función para verificar si el usuario está autenticado
 * @returns {boolean} - True si el usuario está autenticado
 */
export const isAuthenticated = () => {
  const token = getCookie("token")
  return !!token
}

/**
 * Función para obtener el rol del usuario
 * @returns {string|null} - Rol del usuario o null si no está autenticado
 */
export const getUserRole = () => {
  const accountData = getCookie("accountData");
  if (!accountData) return null;

  try {
    // Decodificar la cookie antes de hacer el parseous
    const decodedAccountData = decodeURIComponent(accountData);
    const parsedAccountData = JSON.parse(decodedAccountData);  // Hacer parse del JSON
    return parsedAccountData.user_type;
  } catch (error) {
    console.error("Error al obtener el rol del usuario:", error);
    return null;
  }
};



/**
 * Función para obtener los datos del usuario
 * @returns {Object|null} - Datos del usuario o null si no está autenticado
 */
export const getUserData = () => {
  const userData = getCookie("userData")

  if (!userData) return null

  try {
    return JSON.parse(userData)
  } catch (error) {
    console.error("Error al obtener los datos del usuario:", error)
    return null
  }
}

/**
 * Función para obtener el valor de una cookie por su nombre
 * @param {string} name - Nombre de la cookie
 * @returns {string|null} - Valor de la cookie o null si no se encuentra
 */
export const getCookie = (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(";").shift()
  return null
}